export const ACTIVITY_ACTION_LABEL_MAP: any = {
  // Sensor-based Task lifecycle
  sensor_task_created: { label: 'Sensor-based Task Created', typeSource: 'sensor' },
  sensor_task_ordered: { label: 'Sensor-based Task Ordered', typeSource: 'sensor' },
  sensor_task_cancelled: { label: 'Sensor-based Task Cancelled', typeSource: 'sensor' },
  sensor_task_cancel_requested: { label: 'Sensor-based Task Cancel Requested', typeSource: 'sensor' },
  sensor_task_viewed: { label: 'Sensor-based Task Viewed', typeSource: 'sensor' },
  sensor_task_downloaded: { label: 'Sensor-based Task Downloaded', typeSource: 'sensor' },
  sensor_task_returned: { label: 'Sensor-based Task Returned', typeSource: 'sensor' },
  sensor_task_return_requested: { label: 'Sensor-based Task Return Requested', typeSource: 'sensor' },
  sensor_task_return_rejected: { label: 'Sensor-based Task Return Rejected', typeSource: 'sensor' },

  // Sensor visualization lifecycle
  sensor_task_scene_viewed: { label: 'Sensor-based Task Scene Viewed', typeSource: 'sensor' },
  sensor_task_scene_downloaded: { label: 'Sensor-based Task Scene Downloaded', typeSource: 'sensor' },
  sensor_task_sensor_viewed: { label: 'Sensor-based Task Viewed', typeSource: 'sensor' },
  sensor_task_sensor_downloaded: { label: 'Sensor-based Task Downloaded', typeSource: 'sensor' },
  sensor_task_feed_viewed: { label: 'Sensor-based Task Feed Viewed', typeSource: 'feed' },
  sensor_task_feed_downloaded: { label: 'Sensor-based Task Feed Downloaded', typeSource: 'feed' },

  // Sensor reports lifecycle
  sensor_task_reports_created: { label: 'Sensor-based Task Report Created', typeSource: 'sensor' },
  sensor_task_reports_viewed: { label: 'Sensor-based Task Report Viewed', typeSource: 'sensor' },
  sensor_task_reports_deleted: { label: 'Sensor-based Task Report Deleted', typeSource: 'sensor' },
  sensor_task_reports_downloaded: { label: 'Sensor-based Task Report Downloaded', typeSource: 'sensor' },

  // Sensor product return lifecycle
  sensor_task_vadp_return_requested: { label: 'Sensor-based Task VADP Return Requested', typeSource: 'product' },
  sensor_task_vadp_returned: { label: 'Sensor-based Task VADP Returned', typeSource: 'product' },
  sensor_task_vadp_return_rejected: { label: 'Sensor-based Task VADP Return Rejected', typeSource: 'product' },

  sensor_task_feed_return_requested: { label: 'Sensor-based Task Feed Return Requested', typeSource: 'feed' },
  sensor_task_feed_returned: { label: 'Sensor-based Task Feed Returned', typeSource: 'feed' },
  sensor_task_feed_return_rejected: { label: 'Sensor-based Task Feed Return Rejected', typeSource: 'feed' },

  sensor_task_scene_return_requested: { label: 'Sensor-based Task Scene Return Requested', typeSource: 'sensor' },
  sensor_task_scene_returned: { label: 'Sensor-based Task Scene Returned', typeSource: 'sensor' },
  sensor_task_scene_return_rejected: { label: 'Sensor-based Task Scene Return Rejected', typeSource: 'sensor' },

  sensor_task_sensor_return_requested: { label: 'Sensor-based Task Return Requested', typeSource: 'sensor' },
  sensor_task_sensor_returned: { label: 'Sensor-based Task Returned', typeSource: 'sensor' },
  sensor_task_sensor_return_rejected: { label: 'Sensor-based Task Return Rejected', typeSource: 'sensor' },

  // Collection lifecycle
  collection_created: { label: 'Collection-based Task Created', typeSource: 'sensor' },
  collection_ordered: { label: 'Collection-based Task Ordered', typeSource: 'sensor' },
  collection_cancelled: { label: 'Collection-based Task Cancelled', typeSource: 'sensor' },
  collection_cancel_requested: { label: 'Collection-based Task Cancel Requested', typeSource: 'sensor' },
  collection_viewed: { label: 'Collection-based Task Viewed', typeSource: 'sensor' },
  collection_downloaded: { label: 'Collection-based Task Downloaded', typeSource: 'sensor' },
  collection_returned: { label: 'Collection-based Task Returned', typeSource: 'sensor' },
  collection_return_requested: { label: 'Collection-based Task Return Requested', typeSource: 'sensor' },
  collection_return_rejected: { label: 'Collection-based Task Return Rejected', typeSource: 'sensor' },

  // Collection visualization lifecycle
  collection_scene_viewed: { label: 'Collection-based Task Scene Viewed', typeSource: 'sensor' },
  collection_scene_downloaded: { label: 'Collection-based Task Scene Downloaded', typeSource: 'sensor' },
  collection_sensor_viewed: { label: 'Collection-based Task Viewed', typeSource: 'sensor' },
  collection_sensor_downloaded: { label: 'Collection-based Task Downloaded', typeSource: 'sensor' },
  collection_feed_viewed: { label: 'Collection-based Task Feed Viewed', typeSource: 'feed' },
  collection_feed_downloaded: { label: 'Collection-based Task Feed Downloaded', typeSource: 'feed' },


  // Collection reports lifecycle
  collection_report_created: { label: 'Collection-based Task Report Created', typeSource: 'sensor' },
  collection_report_viewed: { label: 'Collection-based Task Report Viewed', typeSource: 'sensor' },
  collection_report_deleted: { label: 'Collection-based Task Report Deleted', typeSource: 'sensor' },
  collection_report_downloaded: { label: 'Collection-based Task Report Downloaded', typeSource: 'sensor' },

  collection_task_reports_created: { label: 'Collection-based Task Report Created', typeSource: 'sensor' },
  collection_task_reports_viewed: { label: 'Collection-based Task Report Viewed', typeSource: 'sensor' },
  collection_task_reports_deleted: { label: 'Collection-based Task Report Deleted', typeSource: 'sensor' },
  collection_task_reports_downloaded: { label: 'Collection-based Task Report Downloaded', typeSource: 'sensor' },

  // Collection return lifecycle
  collection_feed_return_requested: { label: 'Collection-based Task Feed Return Requested', typeSource: 'feed' },
  collection_feed_returned: { label: 'Collection-based Task Feed Returned', typeSource: 'feed' },
  collection_feed_return_rejected: { label: 'Collection-based Task Feed Return Rejected', typeSource: 'feed' },

  collection_scene_return_requested: { label: 'Collection-based Task Scene Return Requested', typeSource: 'sensor' },
  collection_scene_returned: { label: 'Collection-based Task Scene Returned', typeSource: 'sensor' },
  collection_scene_return_rejected: { label: 'Collection-based Task Scene Return Rejected', typeSource: 'sensor' },

  collection_sensor_return_requested: { label: 'Collection-based Task Return Requested', typeSource: 'sensor' },
  collection_sensor_returned: { label: 'Collection-based Task Returned', typeSource: 'sensor' },
  collection_sensor_return_rejected: { label: 'Collection-based Task Return Rejected', typeSource: 'sensor' },

  // Feed lifecycle
  feed_added: { label: 'Feed Added', typeSource: 'feed' },
  feed_ordered: { label: 'Feed Ordered', typeSource: 'feed' },
  feed_cancelled: { label: 'Feed Cancelled', typeSource: 'feed' },
  feed_cancel_requested: { label: 'Feed Cancel Requested', typeSource: 'feed' },
  feed_viewed: { label: 'Feed Viewed', typeSource: 'feed' },
  feed_downloaded: { label: 'Feed Downloaded', typeSource: 'feed' },
  feed_returned: { label: 'Feed Returned', typeSource: 'feed' },
  feed_return_requested: { label: 'Feed Return Requested', typeSource: 'feed' },
  feed_return_rejected: { label: 'Feed Return Rejected', typeSource: 'feed' },

  feed_removed: { label: 'Feed Removed', typeSource: 'feed' },
  feed_audio_downloaded : { label: 'Sensor-based Audio Downloaded', typeSource: 'sensor' },
  feed_rawdata_downloaded : { label: 'Sensor-based Raw Data Downloaded', typeSource: 'sensor' },

  // Question-based Task lifecycle
  qs_task_created: { label: 'Question-based Task Created', typeSource: 'question' },
  qs_task_ordered: { label: 'Question-based Task Ordered', typeSource: 'question' },
  qs_task_cancelled: { label: 'Question-based Task Cancelled', typeSource: 'question' },
  qs_task_cancel_requested: { label: 'Question-based Task Cancel Requested', typeSource: 'question' },
  qs_task_viewed: { label: 'Question-based Task Viewed', typeSource: 'question' },
  qs_task_downloaded: { label: 'Question-based Task Downloaded', typeSource: 'question' },
  qs_task_returned: { label: 'Question-based Task Returned', typeSource: 'question' },
  qs_task_return_requested: { label: 'Question-based Task Return Requested', typeSource: 'question' },
  qs_task_return_rejected: { label: 'Question-based Task Return Rejected', typeSource: 'question' },

  // QS visualization lifecycle
  qs_task_sensor_viewed: { label: 'Question-based Task Viewed', typeSource: 'question' },

  // QS return lifecycle
  qs_task_vadp_return_requested: { label: 'Question-based Task VADP Return Requested', typeSource: 'question' },
  qs_task_vadp_returned: { label: 'Question-based Task VADP Returned', typeSource: 'question' },
  qs_task_vadp_return_rejected: { label: 'Question-based Task VADP Return Rejected', typeSource: 'question' },

  qs_task_sensor_return_requested: { label: 'Question-based Task Return Requested', typeSource: 'question' },
  qs_task_sensor_returned: { label: 'Question-based Task Returned', typeSource: 'question' },
  qs_task_sensor_return_rejected: { label: 'Question-based Task Return Rejected', typeSource: 'question' },

  qs_task_reports_created : { label: 'Question-based Task Report Created', typeSource: 'question' },
  qs_task_reports_viewed : { label: 'Question-based Task Report Viewed', typeSource: 'question' },
  qs_task_reports_deleted : { label: 'Question-based Task Report Deleted', typeSource: 'question' },
  qs_task_reports_downloaded : { label: 'Question-based Task Report Downloaded', typeSource: 'question' },

  // Budget lifecycle
  budget_saved: { label: 'Budget Task Saved', typeSource: 'sensor' },
  budget_tasked: { label: 'Budget Task Executed', typeSource: 'sensor' },
  budget_task_added : { label: 'Budget Task Added', typeSource: 'sensor' },
  budget_task_created: { label: 'Budget Task Created', typeSource: 'sensor' },
  budget_task_ordered: { label: 'Budget Task Ordered', typeSource: 'sensor' },
  budget_task_scene_viewed: { label: 'Budget Task Scene Viewed', typeSource: 'sensor' },
  budget_task_scene_downloaded: { label: 'Budget Task Scene Downloaded', typeSource: 'sensor' },
  budget_task_sensor_viewed: { label: 'Budget Task Viewed', typeSource: 'sensor' },
  budget_task_sensor_downloaded: { label: 'Budget Task Downloaded', typeSource: 'sensor' },
  budget_task_feed_viewed: { label: 'Budget Task Feed Viewed', typeSource: 'sensor' },
  budget_task_feed_downloaded: { label: 'Budget Task Feed Downloaded', typeSource: 'sensor' },
  
  budget_task_cancelled: { label: 'Budget Task Cancelled', typeSource: 'sensor' },
  budget_task_cancel_requested: { label: 'Budget Task Cancel Requested', typeSource: 'sensor' },
  budget_task_returned: { label: 'Budget Task Returned', typeSource: 'sensor' },
  budget_task_return_requested: { label: 'Budget Task Return Requested', typeSource: 'sensor' },
  budget_task_return_rejected: { label: 'Budget Task Return Rejected', typeSource: 'sensor' },
  budget_task_vadp_return_requested: { label: 'Budget Task VADP Return Requested', typeSource: 'product' },
  budget_task_vadp_returned: { label: 'Budget Task VADP Returned', typeSource: 'product' },
  budget_task_vadp_return_rejected: { label: 'Budget Task VADP Return Rejected', typeSource: 'product' },
  
  budget_task_feed_return_requested: { label: 'Budget Task Feed Return Requested', typeSource: 'feed' },
  budget_task_feed_returned: { label: 'Budget Task Feed Returned', typeSource: 'feed' },
  budget_task_feed_return_rejected: { label: 'Budget Task Feed Return Rejected', typeSource: 'feed' },
  budget_task_scene_return_requested: { label: 'Budget Task Scene Return Requested', typeSource: 'sensor' },
  budget_task_scene_returned: { label: 'Budget Task Scene Returned', typeSource: 'sensor' },
  budget_task_scene_return_rejected: { label: 'Budget Task Scene Return Rejected', typeSource: 'sensor' },
  budget_task_sensor_return_requested: { label: 'Budget Task Return Requested', typeSource: 'sensor' },
  budget_task_sensor_returned: { label: 'Budget Task Returned', typeSource: 'sensor' },
  budget_task_sensor_return_rejected: { label: 'Budget Task Return Rejected', typeSource: 'sensor' },

  budget_task_reports_created: { label: 'Budget Task Report Created', typeSource: 'sensor' },
  budget_task_reports_viewed: { label: 'Budget Task Report Viewed', typeSource: 'sensor' },
  budget_task_reports_deleted: { label: 'Budget Task Report Deleted', typeSource: 'sensor' },
  budget_task_reports_downloaded: { label: 'Budget Task Report Downloaded', typeSource: 'sensor' },

  
  // VADP lifecycle
  vadp_added: { label: 'VADP Added', typeSource: 'product' },
  vadp_ordered: { label: 'VADP Ordered', typeSource: 'product' },
  vadp_cancelled: { label: 'VADP Cancelled', typeSource: 'product' },
  vadp_cancel_requested: { label: 'VADP Cancel Requested', typeSource: 'product' },
  vadp_viewed: { label: 'VADP Viewed', typeSource: 'product' },
  vadp_downloaded: { label: 'VADP Downloaded', typeSource: 'product' },
  vadp_returned: { label: 'VADP Returned', typeSource: 'product' },
  vadp_return_requested: { label: 'VADP Return Requested', typeSource: 'product' },
  vadp_return_rejected: { label: 'VADP Return Rejected', typeSource: 'product' },

  request_approved : { label: 'Permission Request Approved', typeSource: 'sensor' },
  request_rejected : { label: 'Permission Request Rejected', typeSource: 'sensor' },
  cancel_requested : { label: 'Permission Cancel Requested', typeSource: 'sensor' },

  collection_vadp_return_requested: { label: 'Collection-based Task VADP Return Requested', typeSource: 'product' },
  collection_vadp_returned: { label: 'Collection-based Task VADP Returned', typeSource: 'product' },
  collection_vadp_return_rejected: { label: 'Collection-based Task VADP Return Rejected', typeSource: 'product' },

  sensor_task_vadp_viewed : { label: 'Sensor-based Task VADP Viewed', typeSource: 'product' },
  sensor_task_vadp_downloaded : { label: 'Sensor-based Task VADP Downloaded', typeSource: 'product' },

  collection_vadp_viewed : { label: 'Collection-based Task VADP Viewed', typeSource: 'product' },
  collection_vadp_downloaded : { label: 'Collection-based Task VADP Downloaded', typeSource: 'product' },
  
  budget_task_vadp_viewed : { label: 'Budget-based Task VADP Viewed', typeSource: 'product' },
  budget_task_vadp_downloaded : { label: 'Budget-based Task VADP Downloaded', typeSource: 'product' },

  qs_task_scene_return_requested: { label: 'Question-based Task Return Requested', typeSource: 'question' },
  qs_task_scene_returned: { label: 'Question-based Task Returned', typeSource: 'question' },
  qs_task_scene_return_rejected: { label: 'Question-based Task Return Rejected', typeSource: 'question' },
};
